import { gql } from "@apollo/client";export default gql`mutation deleteWorksheet($id: Int!) {
    deleteWorksheet: delete_worksheet_worksheet_by_pk(id: $id) {
        id
    }
}
`;
